import { stringify } from "querystring";
import { Dispatch } from "react-redux";
import { IStore } from "reducers";
import { CANCELLED_STYLES } from "constants/action-types";
import { IOrderStylesPayload } from "reducers/cancelled-styles-reducers";
import { ICancelledStyle } from "constants/cancelled-styles-types";
import { IBaseParams } from "constants/types";

export interface IDropParams {
    orders: string[];
    products: string[];
    canCancel?: boolean;
    message?: string;
}

export interface IFetchParams extends IBaseParams {
    productFields?: string;
    orderFields?: string;
}

export function fetchCancelledStyles(params: IFetchParams, next: boolean) {
    return (dispatch: Dispatch<{}>, getState: () => IStore) => {
        const { nextPage } = getState().cancelledStyles.styles;
        if (next && !nextPage) {
            return;
        }
        let url = nextPage;
        if (!next || !url) {
            const { filters, search, sort, sortOrder, limit = 50, orderFields, productFields } = params;
            const query = {
                __limit: limit,
                __search: search,
                __sort: sort,
                __sort_order: sortOrder,
                __fields_product: productFields || "__all",
                __fields_order: orderFields,
                ...filters.toJS(),
            };
            url = `/api/v3.0/cancelled-styles/styles?${stringify(query)}`;
        }
        if (!next) {
            dispatch({ type: CANCELLED_STYLES.STYLES.UPDATE, payload: { payload: [] } });
        }
        dispatch({ type: CANCELLED_STYLES.STYLES.FETCH.START, payload: { url, next } });
    };
}

export const getCancelledOrdersCount = (brandId: string) => ({
    type: CANCELLED_STYLES.ORDERS.COUNT,
    payload: { url: "/api/v3.0/cancelled-styles/count/orders", activeBrand: brandId },
});

export const getCancelledStylesCount = (brandId: string) => ({
    type: CANCELLED_STYLES.STYLES.COUNT,
    payload: { url: "/api/v3.0/cancelled-styles/count/styles", activeBrand: brandId },
});

export const getCancelledStylesOrder = (id: string) => ({
    type: CANCELLED_STYLES.ORDER.FETCH.START,
    payload: { url: `/api/v3.0/order/${id}?__fields=__all&__populate=__item&__meta=true` },
});

export const resetCancelledStylesOrder = () => ({
    type: CANCELLED_STYLES.ORDER.UPDATE,
    payload: null,
});

export const getCancelledStyle = (id: string) => {
    const query: any = {
        __fields_product: "__all",
        __fields_order:
            "__order_number,__cancelled_total,__cancelled_units,__company.__name,__status,__rep.__name,__currency_code,__created_on,__total",
    };

    return {
        type: CANCELLED_STYLES.STYLE.FETCH.START,
        payload: { url: `/api/v3.0/cancelled-styles/styles/${id}?${stringify(query)}` },
    };
};

export const updateStyleState = (payload: ICancelledStyle) => ({
    type: CANCELLED_STYLES.STYLE.UPDATE,
    payload,
});

export const dropStyles = (body: IDropParams) => ({
    type: CANCELLED_STYLES.DROP.START,
    payload: { url: "/api/v3.0/cancelled-styles/drop", body },
});

export const fetchOrderStyles = (id: string) => {
    const query = {
        __fields_order: "__order_number,__cancelled_units,__company.__name,__status_name,__total,__currency_code",
    };

    return {
        type: CANCELLED_STYLES.ORDER_STYLES.FETCH.START,
        payload: { url: `/api/v3.0/cancelled-styles/orders/${id}?${stringify(query)}` },
    };
};

export const updateOrderStylesState = (payload: IOrderStylesPayload) => ({
    type: CANCELLED_STYLES.ORDER_STYLES.UPDATE,
    payload,
});
